$(document).ready(function() {
	// Accorditon
	let $accordion = $('.customer-logged-in .accordion-items'), $titles = $('.accordion-title', $accordion)
	if ($accordion.length > 0) {
		$accordion.find('.accordion-text').slideUp();
		$titles.on('click', function() {
			let parent = $(this).parent('.accordion');
			if ($(this).hasClass('show')) {
				$(this).removeClass('show');
				parent.find('.accordion-text').slideUp();
			} else {
				$(this).addClass('show');
				parent.find('.accordion-text').slideDown();
			}
		})
	}
	// Account Loyalty Page
	let container = document.querySelector('.account-page.container'), hash, cid, point, value, step2, step2_btn, step3, step3_code, step3_copy, step1, step1_btn, step2_btn_fn, step1_btn_fn;
	if (container) {
		hash = container.dataset.hash;
		cid = container.dataset.cid;
		point = container.querySelector('.loyalty-balance .info-block span');
		value = container.querySelector('.loyalty-value .info-block span');
		step2 = container.querySelector('.step-2');
		step2_btn = step2.querySelector('.button');
		step3 = container.querySelector('.step-3');
		step3_code = container.querySelector('textarea.copy');
		step3_copy = step3.querySelector('.copy_btn');
		step1 = container.querySelector('.step-1');
		step1_btn = step1.querySelector('.button');
		step2_btn_fn = function() {
			step2_btn.setAttribute('disabled', true);
			$.ajax({
				method: 'POST',
				dataType: 'json',
				url: window.location.href + '/' + cid + '/convert_all?hash=' + hash,
				success: function(res) {
					if (res['status'] !== 0) {
						step2_btn.removeAttribute('disabled');
						alert(res['message']);
						return console.error(res);
					}
					point.innerText = res['data']['new_balance'];
					value.innerText = window.Shopify.formatMoney(0);
					step3_code.innerText = res['data']['coupon'].toUpperCase().match(/.{1,4}/g).join(' ');
					step2.classList.add('hidden');
					step3.classList.remove('hidden');
				}
			})
		};
		step1_btn_fn = function() {
			step1.classList.add('hidden')
			step2.classList.remove('hidden');
			step2_btn.addEventListener('click', step2_btn_fn);
		};
		// Bind Event
		step3_copy.addEventListener('click', function() {
			step3_code.select();
			step3_code.setSelectionRange(0, 1000);
			document.execCommand('copy');
		});

		$.ajax({
			method: 'GET',
			dataType: 'json',
			url: '/apps/ps/loyalty/' + cid + '?hash=' + hash,
			success: function(res) {
				if (res['status'] !== 0) {
					if (container) step1_btn.innerText = step1_btn.dataset.text;
					return console.error(res)
				};
				// Account Loyalty Page
				point.innerText = res['data']['points'];
				value.innerText = window.Shopify.formatMoney(res['data']['values']);
				step1_btn.innerText = step1_btn.dataset.text;
				if (res['data']['values'] <= 0) return;
				step1_btn.removeAttribute('disabled');
				step1_btn.addEventListener('click', step1_btn_fn);
			}})
	}
});
